export default __webpack_public_path__ + "static/media/service9.eb0c8088.png";